// import axios from "axios";
import './App.css';
import Vote from "./components/Vote";
import Nav from "./components/Nav";
import Footer from "./components/Footer";

function App() {


  return (
    <div className="App">
      <Nav />
      <Vote />
      <Footer />      
    </div>
  );
}

export default App;
